"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M17 17.97V10.9c-2.28-.46-4-2.48-4-4.9 0-.34.03-.68.1-1H7v12.97l5-2.14z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M17.83 9 15 6.17l1.41-1.41 1.41 1.41 3.54-3.54 1.41 1.41zM17 17.97l-5-2.14-5 2.14V5h6.1c.15-.74.46-1.42.9-2H7c-1.1 0-2 .9-2 2v16l7-3 7 3V10.9c-.32.07-.66.1-1 .1s-.68-.03-1-.1z"
}, "1")], 'BookmarkAddedTwoTone');